module.exports = __webpack_public_path__ + "img/bird.a7df2db1.jpg";